var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "magnum_bottle",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m47.29,24.692c-.041,1.208-.413,5.03-1.061,9.011-.733,4.508-3.675,12.105-4.128,13.463-.453,1.359-2.572,7.234-3.104,11.265-.554,4.193-.501,15.928-.367,18.271.078,1.371.037,6.39.099,9.41.021,1.034.864,1.859,1.898,1.862,4.36.011,14.392.035,18.748.019,1.033-.004,1.873-.829,1.894-1.861.063-3.018.02-8.054.099-9.429.135-2.344.188-14.08-.366-18.273h0c-.532-4.032-2.651-9.906-3.104-11.264-.453-1.359-3.394-8.955-4.128-13.463-.647-3.98-1.02-7.805-1.061-9.012v-10.337c0-.527-.427-.953-.953-.953h-3.61c-.525,0-.949.423-.945.948l.088,10.342Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }